import React, { useState } from 'react';
import { Grid } from '@mui/material';
import { PromoButton } from '../../pages/postajob/components/PromoButton';
import {
  JobTypes,
  ONGOING_JOB_POST_FEE,
  PREMIUM_BOOST_PRICE,
} from '../../data/jobs';
import { useTranslation } from 'react-i18next';
import './PromoButtons.scss';

export enum PromoType {
  Boost = 'Boost',
  Free = 'Free',
}

const PromoButtons = ({
  onClick,
  type,
  jobType,
}: {
  onClick: (promoType: PromoType) => void;
  type?: PromoType;
  jobType?: string;
}) => {
  const [promoType, setPromoType] = useState(type || PromoType.Boost);
  const { t } = useTranslation('translation', {
    keyPrefix: 'create_job.step_review',
  });

  const handleClick = (type: PromoType) => {
    setPromoType(type);
    onClick(type);
  };

  return (
    <Grid
      className={`promo-buttons ${type ? 'center' : ''}`}
      container
      direction="row"
      wrap="nowrap"
    >
      <PromoButton
        title={
          jobType !== JobTypes.ONGOING ? 'Boost your job' : 'Job posting fee'
        }
        description={[
          jobType !== JobTypes.ONGOING
            ? t('promo_pack.boost.description.job_pinned')
            : null,
          t('promo_pack.boost.description.job_review'),
          t('promo_pack.boost.description.job_optimized'),
          t('promo_pack.boost.description.dedicated_instagram_story'),
          t('promo_pack.boost.description.added_weekly_overview'),
          t('promo_pack.boost.description.newsletters'),
        ]}
        count={`+ €${
          jobType !== JobTypes.ONGOING
            ? PREMIUM_BOOST_PRICE
            : ONGOING_JOB_POST_FEE
        },00`}
        isSelected={promoType === PromoType.Boost}
        onClick={() => handleClick(PromoType.Boost)}
      />

      {jobType !== JobTypes.ONGOING && !type && (
        <PromoButton
          title={'No promo'}
          description={[t('promo_pack.no_promo.description.visible')]}
          count={'Free'}
          isSelected={promoType === PromoType.Free}
          onClick={() => handleClick(PromoType.Free)}
        />
      )}
    </Grid>
  );
};

export default PromoButtons;
